<template>
  <div class="header mb-3">
    <v-row class="px-1" style="align-items: center">
      <v-col cols="12" xs="5" md="5" sm="8">
        <div>
          <v-tooltip bottom>
            <template v-slot:activator="{ on, attrs }">
              <h1 v-bind="attrs" v-on="on" style="display: inline-flex">
                {{
                form.username && form.username.length > 20
                ? form.username.substring(0, 20) + "..."
                : form.username
                }}
              </h1>
            </template>
            <span v-if="form.username && form.username.length > 20">
              {{
              form.username
              }}
            </span>
          </v-tooltip>
          <div class="d-flex align-center" style="gap: 10px;">
            <h3>Admin View</h3>
            <div v-if="showTrialBadge" class="trial-header-wrap mt-2">
              <v-chip
                color="amber darken-2"
                text-color="white"
                small
                class="trial-chip"
                :loading="loadingTrialHistory"
                @click.stop="openTrialDialog"
              >
                <v-icon left small class="mr-1">mdi-clock-outline</v-icon>
                {{ trialChipLabel }}
              </v-chip>
            </div>
          </div>
        </div>
      </v-col>
      <v-col cols="12" xs="7" md="7" sm="4" class="d-flex justify-space-between align-center">
        <v-btn depressed outlined @click="goToVideos" class="cursor-pointer">
          <v-list-item-icon>
            <v-icon>mdi-video</v-icon>
          </v-list-item-icon>
          <v-list-item-title>How to Videos</v-list-item-title>
        </v-btn>
        <v-btn depressed outlined @click="openSetupGuide" class="cursor-pointer">
          <v-list-item-icon>
            <v-icon>mdi-school-outline</v-icon>
          </v-list-item-icon>
          <v-list-item-title>Setup guide</v-list-item-title>
        </v-btn>
        <v-menu
          v-model="menu"
          :close-on-content-click="false"
          transition="slide-y-transition"
          bottom
          :nudge-width="50"
          offset-y
        >
          <template v-slot:activator="{ on, attrs }">
            <div class="d-flex align-center cursor-pointer" v-bind="attrs" v-on="on">
              <v-avatar size="48">
                <img
                  :src="
                    form.image
                      ? `${imageURL}${form.image}`
                      : '/img/employee/user-profile.png'
                  "
                />
              </v-avatar>
              <div class="mx-2 font-24" style="font-weight: 400">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="
                        form.username && form.username.length > 20 ? attrs : {}
                      "
                      v-on="
                        form.username && form.username.length > 20 ? on : {}
                      "
                    >
                      {{
                      form.username && form.username.length > 20
                      ? form.username.substring(0, 20) + "..."
                      : form.username
                      }}
                    </span>
                  </template>
                  <span v-if="form.username && form.username.length > 20">
                    {{
                    form.username
                    }}
                  </span>
                </v-tooltip>
              </div>

              <v-icon color="black" size="30">mdi-chevron-down</v-icon>
            </div>
          </template>

          <v-card>
            <v-list>
              <div class="d-flex">
                <v-list-item>
                  <v-list-item-avatar class="mx-3 pa-0">
                    <img
                      :src="
                        form.image
                          ? `${imageURL}${form.image}`
                          : '/img/employee/user-profile.png'
                      "
                      alt="John"
                    />
                  </v-list-item-avatar>

                  <v-list-item-content class="ml-0 pl-0">
                    <v-list-item-title>{{ form.username }}</v-list-item-title>
                    <v-list-item-subtitle>
                      {{
                      form.email
                      }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                </v-list-item>
                <!-- <v-btn text class="ma-0" color="black"><v-icon color="black">mdi-pencil</v-icon></v-btn> -->
              </div>
            </v-list>

            <v-divider></v-divider>

            <!-- <v-list-item @click="openSetupGuide" class="cursor-pointer">
              <v-list-item-icon>
                <v-icon>mdi-school-outline</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Setup guide ({{ setupGuideStepCount }} steps)</v-list-item-title>
            </v-list-item>-->

            <!-- <v-list-item @click="goToVideos" class="cursor-pointer">
              <v-list-item-icon>
                <v-icon>mdi-video</v-icon>
              </v-list-item-icon>
              <v-list-item-title>Videos</v-list-item-title>
            </v-list-item>

            <v-divider></v-divider>-->

            <v-card-actions>
              <v-btn block outlined @click="signOut()">
                <span class="text-transform">Logout</span>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>
      </v-col>
    </v-row>

    <v-dialog v-model="showTrialDialog" max-width="520" persistent>
      <v-card class="trial-dialog-card pa-2">
        <v-card-title class="trial-dialog-title d-flex justify-space-between align-start">
          <span>Trial version</span>
          <v-btn icon small aria-label="Close" @click="showTrialDialog = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-2">
          <v-alert
            dense
            outlined
            color="amber darken-2"
            class="trial-note-alert mb-4"
            icon="mdi-information-outline"
          >
            {{ trialVersionLimitations }}
          </v-alert>
          <div v-if="trialPeriod" class="trial-dates">
            <div class="trial-date-row">
              <span class="trial-date-label">Start date</span>
              <span class="trial-date-value">{{ formatTrialDate(trialPeriod.startDate) }}</span>
            </div>
            <div class="trial-date-row mt-2">
              <span class="trial-date-label">Expiry date</span>
              <span class="trial-date-value">{{ formatTrialDate(trialPeriod.endDate) }}</span>
            </div>
          </div>
          <div
            v-else
            class="grey--text text-body-2"
          >Trial dates could not be loaded. If you are on a trial, they will appear after a refresh.</div>
          
        </v-card-text>
        <v-card-actions class="flex-wrap justify-end pb-4 px-4">
          <v-btn text class="mr-2" @click="showTrialDialog = false">Close</v-btn>
          <v-btn color="primary" depressed @click="goToPricingPlans">Plans pricing</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { makeApiCall } from "@/store/apiRequest";
import { getTrialVersionLimitations } from "@/constants/trialVersion";

function isTrialPlanName(planName) {
  const p = String(planName || "")
    .trim()
    .toLowerCase();
  return p === "trial" || p === "free";
}

function isSubscriptionActive(item, now = new Date()) {
  const start = new Date(item.startDate);
  const end = new Date(item.endDate);
  return (
    !Number.isNaN(start.getTime()) &&
    !Number.isNaN(end.getTime()) &&
    now >= start &&
    now <= end
  );
}

function hasActivePaidSubscription(rows, now = new Date()) {
  if (!Array.isArray(rows)) return false;
  return rows.some(
    (item) => isSubscriptionActive(item, now) && !isTrialPlanName(item.planName)
  );
}

export default {
  props: ["form"],
  name: "headercomponent",
  data() {
    return {
      fav: true,
      menu: false,
      message: false,
      hints: true,
      userdata: {},
      userdata: "",
      imageURL: process.env.VUE_APP_IMG_URL,
      showTrialDialog: false,
      trialPeriod: null,
      hasActivePaidSubscription: false,
      loadingTrialHistory: false,
    };
  },
  computed: {
    ...mapGetters(["getEmployeeById"]),
    showTrialBadge() {
      if (this.hasActivePaidSubscription) return false;
      if (this.form && this.form.isPaid === true) return false;
      if (this.form && this.form.isTrial === true) return true;
      return !!this.trialPeriod;
    },
    trialDaysRemaining() {
      if (!this.trialPeriod || !this.trialPeriod.endDate) return null;
      const end = new Date(this.trialPeriod.endDate);
      if (Number.isNaN(end.getTime())) return null;
      const now = new Date();
      const ms = end.getTime() - now.getTime();
      if (ms <= 0) return 0;
      return Math.ceil(ms / (1000 * 60 * 60 * 24));
    },
    trialChipLabel() {
      const days = this.trialDaysRemaining;
      if (days === null) return "Trial version";
      if (days <= 0) return "Trial ends today";
      if (days === 1) return "Trial version — 1 day left";
      return `Trial version — ${days} days left`;
    },
    trialVersionLimitations() {
      return getTrialVersionLimitations(this.trialDaysRemaining);
    },
    setupGuideStepCount() {
      return this.showTrialBadge ? 2 : 3;
    },
  },
  watch: {
    form: {
      deep: true,
      handler() {
        this.loadTrialSubscriptionWindow();
      }
    }
  },
  mounted() {
    this.loadTrialSubscriptionWindow();
  },
  methods: {
    fetchdata() {
      const user_id = localStorage.getItem("user_id");
      if (user_id) {
        this.$store.dispatch("getEmployeeById", user_id).then(() => {
          this.userdata = this.getEmployeeById;
        });
      }
    },
    signOut() {
      localStorage.clear();
      this.$router.push("/");
    },
    goToVideos() {
      this.menu = false;
      this.$router.push("/videos");
    },
    openSetupGuide() {
      this.menu = false;
      localStorage.setItem("showOnboarding", "true");
      localStorage.setItem("onboardingStep", "0");
      if (this.$route.path !== "/overview") {
        this.$router.push("/overview");
      } else {
        this.$root.$emit("roomrounds-open-onboarding");
      }
    },
    openTrialDialog() {
      this.showTrialDialog = true;
      this.loadTrialSubscriptionWindow();
    },
    formatTrialDate(iso) {
      if (!iso) return "—";
      try {
        return new Date(iso).toLocaleString("en-US", {
          dateStyle: "long",
          timeStyle: "short"
        });
      } catch {
        return String(iso);
      }
    },
    async loadTrialSubscriptionWindow() {
      if (!localStorage.getItem("roomround_access_token")) {
        this.trialPeriod = null;
        this.hasActivePaidSubscription = false;
        return;
      }
      this.loadingTrialHistory = true;
      try {
        const res = await makeApiCall(
          "subscriptionPlan/getUserSubscriptionHistory",
          "POST",
          { isPagination: false }
        );
        const rows = res?.data?.data;
        if (!res?.data?.succeeded || !Array.isArray(rows)) {
          this.hasActivePaidSubscription = false;
          if (!(this.form && this.form.isTrial)) this.trialPeriod = null;
          return;
        }
        const now = new Date();
        this.hasActivePaidSubscription = hasActivePaidSubscription(rows, now);
        if (this.hasActivePaidSubscription) {
          this.trialPeriod = null;
          return;
        }
        const row = rows.find(
          (item) =>
            isTrialPlanName(item.planName) && isSubscriptionActive(item, now)
        );
        this.trialPeriod = row
          ? {
              startDate: row.startDate,
              endDate: row.endDate,
              planName: row.planName
            }
          : null;
      } catch {
        this.hasActivePaidSubscription = false;
        if (!(this.form && this.form.isTrial)) this.trialPeriod = null;
      } finally {
        this.loadingTrialHistory = false;
      }
    },
    goToPricingPlans() {
      this.showTrialDialog = false;
      this.$router.push({ path: "/setting", query: { openUpgrade: "1" } });
    }
  }
};
</script>

<style scoped>
.trial-header-wrap {
  display: flex;
  align-items: center;
}
.trial-chip {
  cursor: pointer;
  font-weight: 600;
}
.trial-dialog-card {
  border-radius: 12px;
}
.trial-dialog-title {
  font-size: 1.15rem;
  font-weight: 700;
  color: #1e3a8a;
  padding-bottom: 8px;
}
.trial-dates {
  text-align: left;
}
.trial-date-row {
  display: flex;
  flex-direction: column;
  gap: 4px;
}
.trial-date-label {
  font-size: 12px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}
.trial-date-value {
  font-size: 15px;
  font-weight: 600;
  color: #0f172a;
}
.trial-note-alert {
  font-size: 13px;
  line-height: 1.45;
}
</style>
